import { render } from "./buttonNormal.vue?vue&type=template&id=6180a061&scoped=true"
import script from "./buttonNormal.vue?vue&type=script&lang=js"
export * from "./buttonNormal.vue?vue&type=script&lang=js"

import "./buttonNormal.vue?vue&type=style&index=0&id=6180a061&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6180a061"]])

export default __exports__